import React from 'react';
import { useSelector } from 'react-redux';

import { selectStoreCount } from 'core/selectors/app';

import MerchantLogos from 'core/modules/MerchantLogos/MerchantLogos';
import MarketingBanner from 'core/modules/MarketingBanner/MarketingBanner';
import { ShowOnMQ } from 'core/modules/MediaQueries/MediaQueries';

import HeroBanner from './components/HeroBanner/HeroBanner';
import VideoSection from './components/VideoSection/VideoSection';
import HIWSection from './components/HIWSection/HIWSection';
import FeaturedSection from './components/FeaturedSection/FeaturedSection';
import MemberSection from './components/MemberSection/MemberSection';
import ButtonSection from './components/ButtonSection/ButtonSection';
import Disclaimer from './components/Disclaimer/Disclaimer';

import './Acquisition.scss';

function AcquisitionContainer() {
  const storeCount = useSelector(selectStoreCount);

  return (
    <div className="mn_acquisitionContainer">
      <HeroBanner />
      <MerchantLogos title={`Shop ${storeCount}+ top stores to earn your bonus`} />
      <ShowOnMQ tablet desktop>
        <VideoSection />
        <HIWSection />
      </ShowOnMQ>
      <FeaturedSection />
      <MemberSection />
      <ButtonSection />
      <div className="mn_bottomSectionWrap">
        <ShowOnMQ tablet desktop><MarketingBanner /></ShowOnMQ>
        <Disclaimer />
      </div>
    </div>
  );
}

export default AcquisitionContainer;
